(function() {
  var bar = document.getElementById('sticky-atc-bar');
  var btn = document.getElementById('sticky-atc-btn');
  var mainBtn = document.querySelector('[data-action="add-to-cart"]');

  if (!bar || !mainBtn) return;

  // Mostrar barra cuando el botón principal sale de vista
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (!entry.isIntersecting) {
        bar.classList.remove('sticky-atc-hidden');
      } else {
        bar.classList.add('sticky-atc-hidden');
      }
    });
  }, { threshold: 0 });

  observer.observe(mainBtn);

  // Al hacer clic, simular click en el botón original del tema
  btn.addEventListener('click', function() {
    var originalBtn = document.querySelector('[data-action="add-to-cart"]');
    if (!originalBtn) return;

    // Click en botón original para agregar al carrito (el tema abre el mini cart solo)
    originalBtn.click();

    // Verificar después si el mini cart quedó abierto, si no, abrirlo
    setTimeout(function() {
      var miniCart = document.querySelector('.mini-cart');
      var isOpen = miniCart && (
        miniCart.classList.contains('is-open') ||
        miniCart.classList.contains('open') ||
        miniCart.classList.contains('active') ||
        getComputedStyle(miniCart).visibility === 'visible' ||
        getComputedStyle(miniCart).display !== 'none'
      );
      if (!isOpen) {
        var cartTrigger = document.querySelector('.header__cart-icon');
        if (cartTrigger) cartTrigger.click();
      }
    }, 1000);
  });
})();
